import { useCallback, useEffect, useState } from "react";
import {
  getUserProfileInfo,
  IUserProfileInfo,
} from "../../verificationRequest/network";
import { TCompany } from "../../company/models";

export const useUserProfileInfo = (
  companies: {
    items: TCompany[];
  } | null
): [IUserProfileInfo, boolean, Error | null, () => void] => {
  const [result, setResult] = useState<IUserProfileInfo>(
    {} as IUserProfileInfo
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    if (companies) {
      setIsLoading(true);
      setError(null);
      try {
        const response = await getUserProfileInfo(companies);
        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
        throw e;
      } finally {
        setIsLoading(false);
      }
    }
  }, [companies]);

  useEffect(() => {
    request();
  }, [request]);

  return [result, isLoading, error, request];
};
